<template>
    <div>
        <geometry-element
                selectable
                movable
                resizable
                :connectable="!isReadOnly"
                :deletable="!isReadOnly"
                :id.sync="value.elementView.id"
                :x.sync="value.elementView.x"
                :y.sync="value.elementView.y"
                :width.sync="value.elementView.width"
                :height.sync="value.elementView.height"
                :angle.sync="value.elementView.angle"
                v-on:selectShape="selectedActivity"
                v-on:deSelectShape="deSelectedActivity"
                v-on:dblclick="openPanel"
                v-on:rotateShape="onRotateShape"
                v-on:labelChanged="onLabelChanged"
                v-on:addedToGroup="onAddedToGroup"
                v-on:removeShape="onRemoveShape(value)"
                :label.sync="name"
                :image.sync="setImg"
                :_style="{
                'label-angle':value.elementView.angle,
                'font-weight': 'bold','font-size': '16'
                }"
                v-on:contextmenu.prevent.stop="handleClick($event)"
        >

            <!--v-on:dblclick="$refs['dialog'].open()"-->
            <geometry-rect
                    :_style="{
                        'fill-r': 1,
                        'fill-cx': .1,
                        'fill-cy': .1,
                        'stroke-width': 1.4,
                        'stroke': '#fbc02d',
                        fill: '#fbc02d',
                        'fill-opacity': 1,
                        r: '1',
                        'z-index': '998'
                    }"
            ></geometry-rect>

            <sub-controller
                    :image="'terminal.png'"
                    @click.prevent.stop="handleClick($event)"
            ></sub-controller>

            <sub-elements>
                <!--title-->
                <text-element
                        :sub-width="'100%'"
                        :sub-height="25"
                        :sub-top="0"
                        :sub-left="0"
                        :text="'Pod'">
                </text-element>
                <image-element
                        :image="imgSrc"
                        :sub-top="5"
                        :sub-left="5"
                        :sub-width="25"
                        :sub-height="25"
                >

                </image-element>
            </sub-elements>

            <sub-elements>
                <circle-element
                        v-if="value.status"
                        :sub-bottom="-15"
                        :sub-width="25"
                        :sub-height="25"
                        :sub-align="'center'"
                        :sub-style="{
                            'stroke': statusColor,
                            fill: statusColor,
                            'fill-opacity': 1,
                        }">
                </circle-element>
            </sub-elements>
            <k8s-sub-controller
                    v-for="(connectableType, idx) in filterConnectionTypes" :key="idx"
                    :element="value"
                    :image="connectableType.src"
                    :type="connectableType.component">
            </k8s-sub-controller>
        </geometry-element>

        <property-panel
                v-if="propertyPanel"
                v-model="value"
                :img="imgSrc"
                :readOnly="isReadOnly"
                @close="closePanel"
        >
        </property-panel>

        <vue-context-menu
            :elementId="value.elementView.id"
            :options="menuList"
            :ref="'vueSimpleContextMenu'"
            @option-clicked="optionClicked">
        </vue-context-menu>
    </div>
</template>

<script>
    import Element from "../KubernetesElement";
    import PropertyPanel from './PodPropertyPanel'

    export default {
        mixins: [Element],
        name: 'pod',
        components: {
            "property-panel": PropertyPanel
        },
        props: {},
        computed: {
            defaultStyle() {
                return {}
            },
            className() {
                return 'Pod'
            },
            imgSrc() {
                return `${window.location.protocol + "//" + window.location.host}/static/image/symbol/kubernetes/pod.svg`
            },
            createNew(elementId, x, y, width, height, object) {
                return {
                    _type: this.className(),
                    name: '',
                    namespace: '',
                    namespaceId: '',
                    elementView: {
                        '_type': this.className(),
                        'id': elementId,
                        'x': x,
                        'y': y,
                        'width': width,
                        'height': height,
                        'style': JSON.stringify({}),
                        'angle': 0,
                    },
                    object: object ? object : {
                        "apiVersion": "v1",
                        "kind": "Pod",
                        "metadata": {
                            "name": "",
                            "labels": {
                                "app": ""
                            }
                        },
                        "spec": {
                            "containers": [
                                {
                                    "name": "",
                                    "image": "",
                                    "ports": [
                                        {
                                            "containerPort": 80
                                        }
                                    ]
                                }
                            ]
                        }
                    },
                    advancedAttributePaths: {
                        "spec.containers[0].resources[0]": {
                            "limits": { 
                                "cpu": "100m", 
                                "mem": "512Mi"
                            }
                        },
                        "spec.containers[0].securityContext": {
                            privileged: true
                        }
                    },
                    outboundVolumes: [],
                    connectableType: [ "PersistentVolumeClaim", "ConfigMap", "Secret" ],
                    status: null,
                    inboundDestinationRule: null,
                    outboundConfigMaps: [],
                    outboundSecrets: [],
                }
            },
            name() {
                try {
                    return this.value.object.metadata.name;
                } catch (e) {
                    return "Untitled";
                }
            },
            outboundVolumeNames() {
                try {
                    var names;
                    this.value.outboundVolumes.forEach(element => {
                        names += element.object.metadata.name + ","
                    });
                    return names;
                } catch (e) {
                    return "";
                }
            },
            namespace: {
                get: function () {
                    return this.value.object.metadata.namespace
                },
                set: function (newVal) {
                    this.value.object.metadata.namespace = newVal
                }
            },
            inboundDRuleName() {
                try {
                    return this.value.inboundDestinationRule.metadata.name;
                } catch (e) {
                    return "";
                }
            },
            outboundSecretNames() {
                try {
                    var me = this;
                    var names = "";
                    me.value.outboundSecrets.forEach(el => {
                        names += el.object.metadata.name + "," + el.object.data;
                        me.setEnv(el);
                    });
                    return names;
                } catch (e) {
                    return "";
                }
            },
            outboundConfigMapNames() {
                try {
                    var names = "";
                    this.value.outboundConfigMaps.forEach(el => {
                        names += el.object.metadata.name + ",";
                    });
                    return names;
                } catch (e) {
                    return "";
                }
            },
        },
        data: function () {
            return {};
        },
        created: function () {
            this.menuList.push({name: "kubectl logs " + this.value.object.metadata.name});
            this.menuList.push({name: "kubectl get po -l app=" + this.value.object.metadata.name});
            this.menuList.push({name: "kubectl exec -it " + this.value.object.metadata.name + " -- /bin/sh"});
        },
        mounted: function () {
            var me = this;

            if(me.value.status) {
                me.setStatus()
                me.refresh()
            }

            this.$EventBus.$on(`${me.value.elementView.id}`, function (obj) {
                if (obj.action == "addRelation" && obj.element && obj.element.targetElement && obj.element.targetElement._type == "PersistentVolumeClaim") {
                    var duplicate = me.value.outboundVolumes.find(item => item.elementView.id == obj.element.targetElement.elementView.id)
                    var duplicateIndex = me.value.outboundVolumes.findIndex(item => item.elementView.id == obj.element.targetElement.elementView.id)
                    if (duplicate) {
                        // 재연결 및 업데이트 기능
                        obj.element.sourceElement = me.value
                        me.value.outboundVolumes[duplicateIndex] = obj.element.targetElement
                        me.value.outboundVolumes.__ob__.dep.notify();
                        return true
                    } else {
                        me.value.outboundVolumes.push(obj.element.targetElement);
                    }
                }

                if (obj.action == "deleteRelation" && obj.element && obj.element.targetElement && obj.element.targetElement._type == "PersistentVolumeClaim") {
                    me.value.outboundVolumes.splice(me.value.outboundVolumes.indexOf(obj.element.targetElement), 1);
                }
                if (obj.action == "changeName") {
                    me.namespace = obj.element
                }

                if (obj.action == "addRelation" && obj.element && obj.element.sourceElement && obj.element.sourceElement._type == "DestinationRuleSubset") {
                    me.value.object.metadata.labels.version = obj.element.sourceElement.name;
                    me.value.inboundDestinationRule = obj.element.sourceElement.object;
                }
                if (obj.action == "deleteRelation" && obj.element && obj.element.sourceElement && obj.element.sourceElement._type == "DestinationRuleSubset") {
                    delete me.value.object.metadata.labels.version;
                    me.value.inboundDestinationRule = null;
                }
                
                if (obj.action == "addRelation" && obj.element && obj.element.targetElement && obj.element.targetElement._type == "ConfigMap") {
                    var res = me.value.outboundConfigMaps.some((el) => {
                        if(el.elementView.id == obj.element.targetElement.elementView.id) {
                            return true;
                        }
                    });
                    if(!res) {
                        me.value.outboundConfigMaps.push(obj.element.targetElement);
                    }
                }
                if (obj.action == "deleteRelation" && obj.element && obj.element.targetElement && obj.element.targetElement._type == "ConfigMap") {
                    me.value.outboundConfigMaps.splice(me.value.outboundConfigMaps.indexOf(obj.element.targetElement), 1);
                }

                if (obj.action == "addRelation" && obj.element && obj.element.targetElement && obj.element.targetElement._type == "Secret") {
                    me.value.object.spec.containers[0].env = [];
                    var res = me.value.outboundSecrets.some((el) => {
                        if(el.elementView.id == obj.element.targetElement.elementView.id) {
                            return true;
                        }
                    });
                    if(!res) {
                        me.value.outboundSecrets.push(obj.element.targetElement);
                        // me.setEnv(obj.element.targetElement);
                    }
                }
                if (obj.action == "deleteRelation" && obj.element && obj.element.targetElement && obj.element.targetElement._type == "Secret") {
                    me.value.outboundSecrets.splice(me.value.outboundSecrets.indexOf(obj.element.targetElement), 1);
                }
            })

        },
        watch: {
            name(appName) {
                var me = this;
                me.value.name = appName;
                me.value.object.metadata.labels.app = appName;
                me.value.object.spec.containers[0].name = appName;
                me.menuList.forEach((cmd) => {
                    if(cmd.name.includes('logs')) {
                        cmd.name = "kubectl logs " + appName;
                    }
                    if(cmd.name.includes('-l app=')) {
                        cmd.name = "kubectl get po -l app=" + appName;
                    }
                    if(cmd.name.includes('exec')) {
                        cmd.name = "kubectl exec -it " + appName + " -- /bin/sh";
                    }
                });
            },
            outboundVolumeNames(val) {
                var me = this;
                me.value.object.spec.volumes = [];
                me.value.object.spec.containers[0].volumeMounts = [];
                me.value.outboundVolumes.forEach(element => {
                        me.value.object.spec.volumes.push({
                            "name": element.object.metadata.name,
                            "persistentVolumeClaim": {
                                "claimName": element.object.metadata.name
                            }
                        });
                        me.value.object.spec.containers[0].volumeMounts.push({
                            "mountPath": "/data",
                            "name": element.object.metadata.name
                        });
                    }
                );
            },
            inboundDRuleName(val) {
                var me = this;
                if(val) {
                    me.value.object.metadata.labels.version = val;
                } else {
                    delete me.value.object.metadata.labels.version;
                }
            },
            outboundSecretNames() {
                // var me = this;
                // me.value.object.spec.containers[0].env = [];
            },
            outboundConfigMapNames() {
                var me = this;
                me.value.object.spec.containers[0].envFrom = [];
                me.value.outboundConfigMaps.forEach(cm => {
                    me.value.object.spec.containers[0].envFrom.push({
                        "configMapRef": {
                            "name": cm.object.metadata.name
                        }
                    });
                });
            },
        },
        methods: {
            setStatus() {
                var me = this
                if(me.value.status.containerStatuses) {
                    if(me.value.status.containerStatuses[0].ready) {
                        me.deploySuccess = true
                    } else {
                        me.deploySuccess = false
                    }
                }    

            },
            setEnv(el) {
                var me = this;
                var keyArr = Object.keys(el.object.data);
                me.value.object.spec.containers[0].env = [];
                keyArr.forEach(key => {
                    var env = {
                        'name': key.toUpperCase(),
                        'valueFrom': {
                            'secretKeyRef': {
                                'name': el.object.metadata.name,
                                'key': key
                            }
                        }
                    }
                    me.value.object.spec.containers[0].env.push(env);
                });
                if(me.value.object.spec.containers[0].env.length == 0) {
                    delete me.value.object.spec.containers[0].env
                }
            },
            isConnected(to, from) {
                var connectable = from.connectableType.some((type) => {
                    if(type == to._type) {
                        return true
                    }
                })
                var res = false
                if(connectable) {
                    if(to._type == 'PersistentVolumeClaim' && from.object.spec.volumes) {
                        res = from.object.spec.volumes.some((volume) => {
                            if(volume.name == to.object.metadata.name) {
                                return true
                            }
                        })
                    } else if(to._type == 'ConfigMap' && from.object.spec.containers[0].envFrom) {
                        res = from.object.spec.containers[0].envFrom.some((cm) => {
                            if(cm.configMapRef.name == to.object.metadata.name) {
                                return true
                            }
                        })
                    } else if(to._type == 'Secret' && from.object.spec.containers[0].env) {
                        res = from.object.spec.containers[0].env.some((secret) => {
                            if(secret.valueFrom.secretKeyRef.name == to.object.metadata.name) {
                                return true
                            }
                        })
                    }
                }
                return res
            },
        },
    }
</script>

<style>

</style>